
import BaseApi from "./BaseApi";

export default class CourseService extends BaseApi {


    constructor(){
        super();
    }
 
    /**
     * UPLOAD IMAGES
     * 
     */
    async uploadImageBodyLesson(data)
    {
        return this.http.post(`${this.baseUrl}/stored-files`, data)
        .catch(this.handleErrorResponse);
    }


    async index(filter)
    {
        return this.http.get(`${this.baseUrl}/courses${filter}`)
        .catch(this.handleErrorResponse);
    }




    async storeCourse(data)
    {
        return this.http.post(`${this.baseUrl}/courses`, data)
        .catch(this.handleErrorResponse);
    }


    async getCourse(id)
    {
        return this.http.get(`${this.baseUrl}/courses/${id}`)
        .catch(this.handleErrorResponse);
    }


    async getLesson(id)
    {
        return this.http.get(`${this.baseUrl}/lessons/${id}`)
        .catch(this.handleErrorResponse);
    }

    async getProgress(id)
    {
        return this.http.get(`${this.baseUrl}/courses/${id}/progress`)
        .catch(this.handleErrorResponse);
    }


    async updateCourse(id, data)
    {
        return this.http.put(`${this.baseUrl}/courses/${id}`, data)
        .catch(this.handleErrorResponse);
    }


    async updateLessonBody(id, data){
        return this.http.post(`${this.baseUrl}/lessons/${id}/content`, data)
        .catch(this.handleErrorResponse);
    }

    async storeSection(courseId, data)
    {
        return this.http.post(`${this.baseUrl}/courses/${courseId}/sections`, data)
        .catch(this.handleErrorResponse);
    }

    async storeLesson(sectionId, data)
    {
        return this.http.post(`${this.baseUrl}/sections/${sectionId}/lessons`, data)
        .catch(this.handleErrorResponse);
    }

    async saveProgress(lessonId, data)
    {
        return this.http.post(`${this.baseUrl}/lessons/${lessonId}/progress`, data)
        .catch(this.handleErrorResponse);
    }

   

}